/** Users */
import { combineReducers } from 'redux'
import headerReducer from 'store/reducers/header/headerSlice'
import userReducer from 'store/reducers/user/userSlice'
import appsReducer from 'store/reducers/app/appSlice'

const appReducer = combineReducers({
  user: userReducer,
  header: headerReducer,
  app: appsReducer,
})

export const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined
  }

  return appReducer(state, action)
}
